import type { SiteConfigFn } from '@wix/thunderbolt-vsm-api-types'
import type { CodeEmbedsSiteConfig } from '../types'

const codeEmbedSiteConfig: SiteConfigFn<CodeEmbedsSiteConfig> = ({ api }) => {
	const htmlEmbeds = (api.publicModel.getHtmlEmbeds() || [])
		.filter((embed) => embed)
		.filter((embed) => embed.embedType === 'custom' || embed.embedType === 'verificationCode')

	const shouldLoadSiteFeature = htmlEmbeds.length > 0
	const shouldLoadRequireJS = api.features.isActive('ooi')

	return {
		shouldLoadSiteFeature,
		shouldLoadSiteConfig: shouldLoadSiteFeature,
		siteConfig: {
			htmlEmbeds,
			shouldLoadRequireJS,
		},
	}
}

const name = 'codeEmbed'

export const config = { site: codeEmbedSiteConfig, name }
